import { useNavigate } from "react-router-dom";
import PublicShell from "../components/public/PublicShell";
import { useSeo } from "../lib/useSeo";

const CSS = `
.agz-landing .public-page{padding:72px 0 48px}
.agz-landing .public-page h1{font-size:clamp(38px,5.5vw,64px);letter-spacing:-.035em;margin-bottom:22px;max-width:900px}
.agz-landing .public-page .eyebrow{display:inline-block;font-size:12px;font-weight:600;letter-spacing:.14em;color:var(--muted);text-transform:uppercase;margin-bottom:22px}
.agz-landing .public-page .intro{font-size:clamp(17px,1.6vw,20px);color:var(--ink-soft);line-height:1.55;max-width:760px;margin-bottom:56px}
.agz-landing .public-page .sec{padding:44px 0;border-top:1px solid var(--line-soft)}
.agz-landing .public-page .sec:first-of-type{border-top:0;padding-top:0}
.agz-landing .public-page .sec h2{font-size:clamp(24px,2.6vw,34px);letter-spacing:-.03em;margin-bottom:18px;max-width:820px}
.agz-landing .public-page .sec p{color:var(--ink-soft);font-size:16.5px;line-height:1.7;max-width:760px;margin-bottom:14px}
.agz-landing .steps{display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:16px;margin-top:30px}
.agz-landing .step-card{background:var(--card);border:1px solid var(--line);border-radius:var(--r-card);padding:22px;box-shadow:var(--sh-xs);transition:transform .18s,box-shadow .2s,border-color .2s}
.agz-landing .step-card:hover{transform:translateY(-2px);box-shadow:var(--sh-sm);border-color:#cfc9bd}
.agz-landing .step-card .num{display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:9px;background:var(--ink);color:#fff;font-size:13px;font-weight:600;margin-bottom:14px}
.agz-landing .step-card h3{font-size:16.5px;margin-bottom:8px}
.agz-landing .step-card p{font-size:14px;color:var(--ink-soft);line-height:1.55;margin:0}
.agz-landing .cta-block{margin-top:64px;background:var(--ink);color:#fff;border-radius:24px;padding:clamp(32px,5vw,56px);text-align:center}
.agz-landing .cta-block h2{color:#fff;margin-bottom:24px;font-size:clamp(24px,2.8vw,36px)}
.agz-landing .cta-block .btn--primary{background:#fff;color:var(--ink)}
.agz-landing .cta-block .btn--primary:hover{background:var(--paper-2)}
@media(max-width:520px){.agz-landing .public-page{padding:48px 0 32px}}
`;

export default function About() {
  const nav = useNavigate();
  useSeo({
    title: "About Agenzee | Your AI Marketing Workspace",
    description: "Learn how Agenzee helps businesses turn their brand knowledge into strategy, content, creatives and campaigns from one intelligent workspace.",
    path: "/about",
  });
  return (
    <PublicShell>
      <style>{CSS}</style>
      <div className="public-page" data-testid="about-page">
        <div className="wrap">
          <span className="eyebrow">About Agenzee</span>
          <h1>Marketing should work as one system.</h1>
          <p className="intro">
            Agenzee is an AI marketing workspace built to help businesses move from brand strategy to execution without losing clarity, consistency or control.
          </p>

          <section className="sec">
            <h2>Why Agenzee exists</h2>
            <p>Businesses often manage marketing across disconnected documents, generators, calendars and design tools. Brand information gets repeated, strategies remain separated from execution and AI outputs quickly become generic.</p>
            <p>Agenzee brings these activities together. One shared understanding of the brand powers the strategy, action plan, editorial calendar, scripts, carousels, advertising creatives and landing pages.</p>
          </section>

          <section className="sec">
            <h2>From brand knowledge to action</h2>
            <div className="steps">
              <div className="step-card"><div className="num">01</div><h3>Build your Brand Brain</h3><p>Define your business, audience, positioning, goals and tone of voice.</p></div>
              <div className="step-card"><div className="num">02</div><h3>Create your strategy</h3><p>Turn brand context into a clear marketing direction.</p></div>
              <div className="step-card"><div className="num">03</div><h3>Plan and produce</h3><p>Build action plans, editorial calendars, scripts and campaign assets.</p></div>
              <div className="step-card"><div className="num">04</div><h3>Improve over time</h3><p>Use preferences and corrections to make future outputs increasingly relevant to your brand.</p></div>
            </div>
          </section>

          <section className="sec">
            <h2>Built for businesses</h2>
            <p>Agenzee is designed for companies, entrepreneurs, professionals, startups, ecommerce brands and local businesses that need a more structured way to manage marketing.</p>
            <p>It does not replace judgement, creativity or professional expertise. It gives businesses a faster and more organized foundation from which to plan, create and launch.</p>
          </section>

          <section className="sec">
            <h2>Created by Believe Media Group S.R.L.</h2>
            <p>Agenzee is a product developed by Believe Media Group S.R.L., combining practical marketing experience with artificial intelligence to make high-quality strategy and content production more accessible to businesses.</p>
          </section>

          <div className="cta-block">
            <h2>Turn your brand into a marketing system.</h2>
            <button
              className="btn btn--primary btn--lg"
              onClick={() => nav("/auth")}
              data-testid="about-cta-btn">
              Start with Agenzee
            </button>
          </div>
        </div>
      </div>
    </PublicShell>
  );
}
